import type { BetaSignupInput, BetaSignupResponse } from '@sea-snag/shared';
import { useMutation } from '@tanstack/react-query';

import { betaApi } from '../lib/api-client';

export function useBetaSignup() {
  return useMutation<BetaSignupResponse, Error, BetaSignupInput>({
    mutationFn: (data) => betaApi.create(data),
  });
}
